/* unplugin-vue-components disabled */import { render } from "./DiscountSelectTickets.vue?vue&type=template&id=141ce3a3&scoped=true&ts=true"
import script from "./DiscountSelectTickets.vue?vue&type=script&lang=ts"
export * from "./DiscountSelectTickets.vue?vue&type=script&lang=ts"

import "./DiscountSelectTickets.vue?vue&type=style&index=0&id=141ce3a3&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141ce3a3"]])

export default __exports__